import type { Variants } from 'framer-motion';

/** out-expo：先快后缓、premium feel，比 out-cubic 更克制，适合付费/商业化场景。 */
export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1] as const;

/**
 * 卡片网格容器：仅做 stagger 子项编排，不自身动画，避免双层 fade 叠加。
 * 与 PlanDetail / TeamPlanDetail / ClawPassContent / PurchaseCredits 共用，保持商业化页面动画语言一致。
 */
export const cardsContainerVariants: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

/**
 * 单卡片入场：blur→clear + 轻微上浮 + fade。
 * "对焦上来"的视觉语言，Stripe / Linear / Vercel 定价页常见模式，让用户视线被卡片逐张"显影"吸引。
 * 不使用 scale，避免边框/字体在 transform 期间出现毛刺。
 */
export const cardItemVariants: Variants = {
  hidden: { opacity: 0, y: 12, filter: 'blur(8px)' },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: { duration: 0.55, ease: EASE_OUT_EXPO },
  },
};
